import React, { useState } from "react";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { createStyles, makeStyles, withStyles, Button, Grid, MenuItem } from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import { DELETE_SUBSCRIPTION } from "../../../Services/Graph/Contact/Mutations";
import { authApolloClient } from "../../../Services/Graph/apolloConfig";
import { useMutation } from "@apollo/client";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) =>
  createStyles({
    circle: {
      strokeLinecap: "round",
    },
    progress: {
      color: theme.palette.areaPulseBlue,
      margin: "5px",
    },
    error: {
      fontSize: "18px",
      color: theme.palette.areaPulseError,
      marginBottom: "8px",
      marginLeft: "10px",
    },
    paper: {
      margin: "15px",
      padding: "30px",
      backgroundColor: "#F5F5F5",
      borderRadius: "20px",
      boxShadow: "none",
    },
    contactHeaderContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "30px",
    },
    paperLabel: {
      fontFamily: theme.typography.secondary,
      margin: 0,
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      textTransform: "uppercase",
    },
    areYouSureSubText: {
      fontFamily: theme.typography.secondary,
      margin: 0,
      fontSize: "18px",
      fontWeight: "600",
      color: "#000",
    },
    deleteContactModalTextContainer: {
      display: "flex",
      justifyContent: "center",
    },
    modalActions: {
      display: "flex",
      justifyContent: "center",
      marginTop: "40px",
      marginBottom: "35px",
    },
    personalDetailsForm: {
      width: "100%",
    },
    menuItem: {
      padding: "14px 20px",
    },
    menuItemIcon: {
      marginRight: "12px",
    },
    modalClose: {
      position: "absolute",
      right: "30px",
    },
    closeModalButton: {
      minWidth: "0px",
      padding: "8px",
      borderRadius: "10px",
      "&:hover": {},
    },
    closeModalButtonIcon: {
      color: "#282828",
      fontSize: "30px",
    },
    cancelButton: {
      background: "transparent",
      minWidth: "0px",
      padding: "16px 80px",
      borderRadius: "10px",
      color: "#8D8989",
      "&:hover": {
        background: "transparent",
      },
      marginRight: "10px",
    },
    cancelButtonLabel: {
      fontFamily: theme.typography.secondary,
      color: "#8D8989",
      fontSize: "16px",
      fontWeight: "700",
      margin: 0,
    },
    deleteButton: {
      background: theme.palette.areaPulseError,
      minWidth: "0px",
      padding: "16px 80px",
      borderRadius: "10px",
      color: "#fff",
      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.45)",
      "&:hover": {
        background: theme.palette.areaPulseError,
      },
      marginLeft: "10px",
    },
    deleteButtonLabel: {
      fontFamily: theme.typography.secondary,
      color: "#fff",
      fontSize: "16px",
      fontWeight: "700",
      margin: 0,
    },
    deleteContactNoteButton: {
      background: theme.palette.areaPulseRed,
      minWidth: "0px",
      padding: "8px",
      marginRight: "40px",
      borderRadius: "10px",
      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.45)",
      "&:hover": {
        background: theme.palette.areaPulseRed,
      },
    },
    deleteContactNoteButtonIcon: {
      color: "#fff",
      fontSize: "24px",
    },
  })
);

const Dialog = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialog);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: "0 30px 30px 30px",
  },
}))(MuiDialogContent);

const DeleteSubscriptionModal = ({ subscriptionId, setModalWasClosed, setSubscriptionWasDeleted }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setModalWasClosed(true);
    setOpen(false);
  };

  const [deleteContactSubscription] = useMutation(DELETE_SUBSCRIPTION, {
    variables: {
      id: subscriptionId ?? 0,
    },
    client: authApolloClient,
  });

  return (
    <Grid container justify="center">
      <MenuItem className={classes.menuItem} onClick={handleClickOpen}>
        <DeleteOutlineOutlinedIcon className={classes.menuItemIcon} />
        Unsubscribe
      </MenuItem>
      <Dialog
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: "20px",
            width: "800px",
          },
        }}
        onClose={handleClose}
        aria-labelledby="add-contact-modal"
        open={open}
      >
        <div className={classes.contactHeaderContainer}>
          <h1 className={classes.paperLabel}>Unsubscribe To Report</h1>
          <div className={classes.modalClose}>
            <Button className={classes.closeModalButton} onClick={handleClose}>
              <CloseRounded color="inherit" fontSize="inherit" className={classes.closeModalButtonIcon} />
            </Button>
          </div>
        </div>

        <DialogContent>
          <div className={classes.deleteContactModalTextContainer}>
            <h1 className={classes.areYouSureSubText}>Are you sure you want to unsubscribe from this report?</h1>
          </div>
        </DialogContent>
        <div className={classes.modalActions}>
          <Button onClick={handleClose} className={classes.cancelButton}>
            <h1 className={classes.cancelButtonLabel}>Cancel</h1>
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              deleteContactSubscription();
              setSubscriptionWasDeleted(true);
              handleClose();
            }}
            className={classes.deleteButton}
          >
            <h1 className={classes.deleteButtonLabel}>Unsubscribe</h1>
          </Button>
        </div>
      </Dialog>
    </Grid>
  );
};

DeleteSubscriptionModal.propTypes = {
  subscriptionId: PropTypes.number,
  setContactNoteWasDeleted: PropTypes.func,
  setModalWasClosed: PropTypes.func,
  setSubscriptionWasDeleted: PropTypes.func,
};

export default DeleteSubscriptionModal;
